import React from 'react'
import { InputProps } from '../framework/interfaces'

import useInputHidden from '../framework/hooks/useInputHidden'

const InputHidden: React.FC<InputProps> = (props) => {
  const { name } = props
  const { ctx, elemId } = useInputHidden(props)

  return <input type="hidden" id={elemId} name={name} ref={ctx.register} />
}

export default InputHidden
